import React from 'react';
import Stack from '@mui/material/Stack';
import {ContentBlockHeader} from '@growcloud-io/dc/components/surface/ContentBlockHeader';
import {newColumnStack} from "@growcloud-io/gcio-commons/common/utils/UiUtils";

const markdown = '# Hi, *Pluto*!'

export const HowItWorksPage = ({}) => {
  return (
    <Stack direction={'column'} sx={newColumnStack()}>
      <ContentBlockHeader
        PageTitle={'HOW IT WORKS'}
        SubHeader={''}
        Alignment="left"
      />

    </Stack>
  );
}
